import { Button, Col, Container, Form, Image, Row } from "react-bootstrap";
import { Calender } from "../../../../assets/images";

const ConsultantTab = () => {
    return (
        <div className="consultant_tab_screen">
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <Form>
                            <Form.Group className="form-group">
                                <Form.Label>
                                    Choose Department
                                </Form.Label>
                                <Form.Select required>
                                    <option value="1" selected>Cardiology</option>
                                    <option value="2">Cardiology</option>
                                    <option value="3">Cardiology</option>
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className="form-group">
                                <Form.Label>
                                    Consultant Name
                                </Form.Label>
                                <Form.Control type="text" placeholder="Joseph" />
                            </Form.Group>
                            <div className="btn_area">
                                <Button className="cancelBtn" type="button" >Cancel</Button>
                                <Button className="submitBtn" type="submit">Next</Button>
                            </div>
                        </Form>
                    </Col>
                </Row>
            </Container>
        </div>
    )
};

export default ConsultantTab;